
import * as React from 'react';

import Intro from './Intro';
import Why from './Why';


const Sale = (props) => (
  <div>
    <Intro />
    <Why />
  </div>
);

export default Sale;
